import React, { Component } from "react";
import { Button ,Icon ,Modal } from "antd";
import Fetch from "../../../common/Fetch";
import API_URL from "../../../common/url";
import Filter from "./Filter";
import TableC from "../../basicElement/TableC";
import $ from '../../../common/AjaxRequest';
import addToDownloadSite from '../../common/addToDownloadSite';
import format from "../../shared/format";
import SideNav from "../SideNav";
import ConfigColumn from "./ConfigColumn";
import renderEnhancer from '../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import moment from "moment";

class CollectReport extends Component {
    constructor(props) {
        super(props);
        const searchParams = {
            startOper: "EQ",
            endOper: "EQ",
        };
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: { ...searchParams },
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            endMonth: "",
            startMonth: "",
            operable: false,
            tableHeader:[]
        };
    }

    componentDidMount() {
        this.getHeader()
    }

    loadData = () => {
        const {curParams,pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        Fetch.post(API_URL.dashboard.queryListGroupByMainJdeCustomer, {
            offset: current,
            limit: pageSize,
            ...curParams,
        })
            .then((res) => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                datas.forEach(item => item.openChildList = false)
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ loading: false });
            });
    };

    search = (saveParams) => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        pagination.pageSize = 10;
        this.setState({curParams: { ...saveParams },pagination},
            () => {
                this.loadData();
            }
        );
    };

    export = () => {
        const { sortParams, curParams } = this.state;
        const { areaCity } = curParams;
        const params = this.splitParams(curParams);
        (areaCity || []).forEach(
            (i) => (params[`params[${i.props.title}]`] = i.key)
        );
        const url = API_URL.finance.exportInvSiteRecordInfoList;
        addToDownloadSite({ ...sortParams, ...params }, url, 'INV_SITE_RECORD');
    };

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== "object" || value === null) {
                result[key] = value;
            }
        }
        return result;
    };

    getRender = (key) => (text, record) => (record[key] ? record[key] : text);

    getHeader=()=>{
        const options = {
            method: 'POST',
            url: API_URL.common.queryUserCustomDisplayByUserId,
            data: { type: 'ACCOUNTS_RECEIVABLE'},
            dataType: 'json',
            doneResult: data => {
                const headers = data.ACCOUNTS_RECEIVABLE;
                const tableHeader = [{
                    dataIndex: "tableConfig",
                    displayType: "ACCOUNTS_RECEIVABLE",
                    isDefault: "1",
                    isShow: "1",
                }];
                headers.forEach(head => {
                    if (head.isShow !== "0") {
                        tableHeader.push(head);
                    }
                });
                this.setState({ tableHeader:this.getColumns(tableHeader) },()=>{
                    this.loadData()
                });
            }
        };
        
        $.sendRequest(options);
    }

    getColumns = (tableHeadercolumn) => {
        const columns = [{
                title: <div className="config_clm_oper">
                    <Icon 
                        type="setting" 
                        onClick={() => this.configColumn()} 
                        style={{ float: "right", fontSize: "18px", marginRight: "10px" }} />
                    </div>,
                dataIndex: "tableConfig",
                key: "tableConfig",
                width: 60,
                fixed: 'left',
                render: (text, record, index) => {
                    const { openChildList ,customerCode: childCustomerCode, mainJdeCode, arCodeShow, companyName } = record;
                    if( openChildList == undefined ) {
                        return null
                    }else {
                        return (
                            <span style={{display:'block',textAlign:'center'}}>



                                <Icon 
                                    type={ openChildList ? 'minus-square-o' : 'plus-square-o'} 
                                    onClick={() => openChildList ? 
                                        this.cloceChildList({ childCustomerCode, mainJdeCode, parentArCodeShow: arCodeShow },index) : 
                                        this.openChildList({ childCustomerCode, mainJdeCode, parentArCodeShow: arCodeShow, parentCompanyName: companyName },index)
                                    }
                                />
                            </span>
                        )
                    }
                    
                }
            }, {
                title: '应收账款是否大于0',
                dataIndex: "accountsGreatZero",
                key: "accountsGreatZero",
                width: 80,
                fixed: 'left',
                render: text => text == 1?'是':(text == 0?'否':'-')
            }, {
                title: "AR分类",
                dataIndex: "arCodeShow",
                key: "arCodeShow",
                width: 100,
                fixed: 'left',
            },
            {
                title: "JDE主项目号",
                dataIndex: "mainJdeCode",
                key: "mainJdeCode",
                width: 120,
                fixed: 'left',
            },
            {
                title: "JDE项目号",
                dataIndex: "sectionNCode",
                key: "sectionNCode",
                width: 120,
                fixed: 'left',
            },
            {
                title: "客户名称",
                dataIndex: "customerName",
                key: "customerName",
                width: 120,
            },
            {
                title: "客户JDE号",
                dataIndex: "customerCode",
                key: "customerCode",
                width: 80,
            },
            {
                title: "公司名称",
                dataIndex: "companyName",
                key: "companyName",
                width: 100,
            },
            {
                title: "自定义发票号",
                dataIndex: "invoiceNumber",
                key: "invoiceNumber",
                width: 120,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {invoiceNumber } = record;
                            const invoiceNumberList = invoiceNumber?invoiceNumber.split('//'):[]
                            if ((invoiceNumberList || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            invoiceNumberList.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "Project ID",
                dataIndex: "projectId",
                key: "projectId",
                width: 120,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {projectId } = record;
                            const projectIdList = projectId?projectId.split('//'):[]
                            if ((projectIdList || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            projectIdList.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "关联主键（文件类型）",
                dataIndex: "dct",
                key: "dct",
                width: 100,
            },
            {
                title: "发票日期",
                dataIndex: "invoiceDateShow",
                key: "invoiceDateShow",
                width: 110,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {invoiceDateShow } = record;
                            const invoiceDateShowList = invoiceDateShow?invoiceDateShow.split('//'):[]
                            if ((invoiceDateShowList || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            invoiceDateShowList.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "请款单号",
                dataIndex: "poNumber2",
                key: "poNumber2",
                width: 100,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {poNumber2 } = record;
                            const poNumber2List = poNumber2?poNumber2.split('//'):[]
                            if ((poNumber2List || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            poNumber2List.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "Close date",
                dataIndex: "closeDateShow",
                key: "closeDateShow",
                width: 100,
            },
            {
                title: "币种",
                dataIndex: "currency",
                key: "currency",
                width: 85,
                render: (text , row ) => {
                    const { originalCurrency } = row;
                    return originalCurrency  === 'CNY'?text:(<span style={{color :'red'}}>{text}</span>)
                }
            },
            {
                title: "信用期",
                dataIndex: "creditTerms",
                key: "creditTerms",
                width: 160,
            },
            {
                title: "信用额度",
                dataIndex: "creditLimit",
                key: "creditLimit",
                width: 100,
            },
            {
                title: "信用期内",
                dataIndex: "forFuture",
                key: "forFuture",
                width: 100,
            },
            {
                title: "31天以内（逾期）",
                dataIndex: "less31",
                key: "less31",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "31~60天（逾期）",
                dataIndex: "day31To60",
                key: "day31To60",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "61~90天（逾期）",
                dataIndex: "day61To90",
                key: "day61To90",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "91~120天（逾期）",
                dataIndex: "day91To120",
                key: "day91To120",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "121~150天（逾期）",
                dataIndex: "day121To150",
                key: "day121To150",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "151~180天（逾期）",
                dataIndex: "day151To180",
                key: "day151To180",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "181~365天（逾期）",
                dataIndex: "day181To365",
                key: "day181To365",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "366~730天（逾期）",
                dataIndex: "day366To730",
                key: "day366To730",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: '731~1095天（逾期）',
                dataIndex: 'day731To1095',
                key: 'day731To1095',
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "1095天以上（逾期）",
                dataIndex: "great1095",
                key: "great1095",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "120天以上合计",
                dataIndex: "sumGreat120",
                key: "sumGreat120",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "365天以上合计",
                dataIndex: "sumGreat365",
                key: "sumGreat365",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "所有金额合计",
                dataIndex: "amount",
                key: "amount",
                width: 100,
                render: text => format('money', text), 
            },
            {
                title: "批号",
                dataIndex: "batchNo",
                key: "batchNo",
                width: 100,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {batchNo } = record;
                            const batchNoList = batchNo?batchNo.split('//'):[]
                            if ((batchNoList || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            batchNoList.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "总账日期",
                dataIndex: "glDateShow",
                key: "glDateShow",
                width: 100,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {glDateShow } = record;
                            const glDateShowList = glDateShow?glDateShow.split('//'):[]
                            if ((glDateShowList || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            glDateShowList.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "制单人工号",
                dataIndex: "createrCode",
                key: "createrCode",
                width: 100,
            },
            {
                title: "PO Number1",
                dataIndex: "poNumber1",
                key: "poNumber1",
                width: 100,
            },
            {
                title: "负责人",
                dataIndex: "charegeUser",
                key: "charegeUser",
                width: 80,
            },
            {
                title: "制单人名称",
                dataIndex: "creaternName",
                key: "creaternName",
                width: 90,
            },
            {
                title: "类别码15描述",
                dataIndex: "serviceType",
                key: "serviceType",
                width: 90,
            },
            {
                title: "到期日",
                dataIndex: "dueDateShow",
                key: "dueDateShow",
                width: 100,
                render: renderEnhancer(
                    cellRenderEnhancer({
                        renderContent: record => {
                            const {dueDateShow } = record;
                            const dueDateShowList = dueDateShow?dueDateShow.split('//'):[]
                            if ((dueDateShowList || []).length > 1) {
                                return (
                                    <div>
                                        {
                                            dueDateShowList.map((value,index) => (
                                                <div key={index}>
                                                    {value} 
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            }
                        }
                    })(text => text?text.split('//')[0]:'')
                ),
            },
            {
                title: "税率",
                dataIndex: "taxRate",
                key: "taxRate",
                width: 80,
                render: text=>text+'%'
            },
            {
                title: "类别码13描述",
                dataIndex: "code13Desc",
                key: "code13Desc",
                width: 120,
            },
            {
                title: "BillingSite",
                dataIndex: "billingSite",
                key: "billingSite",
                width: 80,
            },
            {
                title: "actualsite",
                dataIndex: "actualSite",
                key: "actualSite",
                width: 80,
            },{
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                render: (text, record, index) => {
                    return (
                        <Popconfirm title="确定删除该记录?" onConfirm={() => this.handleDelete(index)}>
                            <a>删除</a>
                        </Popconfirm>
                        
                    )
                }
            }
        ];
        let result=[]
        tableHeadercolumn.forEach(item => {
            const { isShow, dataIndex } = item;
            if (isShow === '1' || showAll) {
                const column = columns.find(i => i.dataIndex === dataIndex) || {};
                result.push(column);
            }
        });
    return result;
    };

    openChildList = (params, index)=>{
        const {data , pagination, curParams } = this.state;curParams
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryAccountsReceivableList,
            data: {...params, ...curParams},
            dataType: 'json',
            doneResult: res => {
                const record = res.datas;
                pagination.total = pagination.total + (Math.ceil(pagination.total / pagination.pageSize)) * record.length;
                pagination.pageSize = pagination.pageSize + record.length;
                data[index].openChildList = true;
                data.splice( index + 1, 0, ...record )
                let newData = [...data]
                this.setState({
                    data: newData, 
                    pagination,
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
        
    }

    cloceChildList = (params, index)=>{
        const {data , pagination, curParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryAccountsReceivableList,
            data: {...params, ...curParams},
            dataType: 'json',
            doneResult: res => {
                const  record = res.datas;
                pagination.total = pagination.total - (Math.ceil(pagination.total / pagination.pageSize)) * record.length;
                pagination.pageSize = pagination.pageSize - record.length;
                data[index].openChildList = false;
                data.splice( index + 1, record.length)
                let newData = [...data]
                this.setState({data:newData,pagination})
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }
    
    configColumn =()=>{
        this.configColumnRef.show()
    }

    handleTableChange = (params) => {
        let { pagination } = params;
        pagination.pageSize = 10;
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    queryTaskStatus = () => {
        const options = {
            method: 'POST',
            url: API_URL.dashboard.accountsReceivableSync,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const {status} =res;
                if(status ==='success'){
                    const {success} =res;
                    Modal.success({
                        title: success,
                    });
                } else if(status === 'fail'){
                    Modal.warning({
                        title: '刷新统计任务正在进行中，请稍后再试！',
                    });
                }
            },
            errorResult: rej =>{
                console.log('rej',rej);
            }
        }
        $.sendRequest(options);
    }

    render() {
        const {
            data,
            loading,
            pagination,
            sortParams,
            operable,
            tableHeader
        } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="collectReport" />
                <div className="main">
                    <Filter
                        operable={operable}
                        expandHeight={160}
                        search={this.search}
                    />
                    <div style={{color:'red',fontSize:'14px',marginBottom:'10px'}}>注：金额计算结果单位均为“人民币（CNY）”，外币会根据汇率自动转换</div>
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={tableHeader}
                        rowKey="investigationJdeContractRecordId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <ConfigColumn ref={el => this.configColumnRef = el} loadData={this.getHeader}/>
                    <div className="pin-right">
                        <div className="pin pin-refresh" onClick={this.queryTaskStatus}><Icon type="sync" />刷新统计</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CollectReport;



// WEBPACK FOOTER //
// ./src/components/financeManagement/collectReport/index.js